<template>
  <div class="loading-bar">
    <h2>{{$t('quiz.loading.title')}}</h2>

    <div class="loading__steps">
      <div v-for="step in progressbarSteps" :key="step.name" class="step">
        <div class="step__header">
          <p>{{step.name}}</p>
          <div class="percentage">{{Math.round(step.progress)}}%</div>
        </div>

        <div class="progress">
          <div class="current-progress" :style="{width: step.progress + '%'}"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingProgress",

  inject: ["mediaBaseUrl"],

  props: ['gender'],

  data() {
    return {
      countDown: 1.5,
      progress: 0,
      progressbarSteps: [
        {
          name: this.$t('quiz.loading.steps[0]'),
          progress: 0,
        },
        {
          name: this.$t('quiz.loading.steps[1]'),
          progress: 0,
        },
        {
          name: this.$t('quiz.loading.steps[2]'),
          progress: 0,
        },
        {
          name: this.$t('quiz.loading.steps[3]'),
          progress: 0,
        },
      ],
      activeStep: 0,
      timer: null,
    };
  },

  computed: {
    progressBarColor() {
      if (this.progress < 30) {
        return 'rgba(255, 92, 0, 1)';
      } else if (this.progress < 60) {
        return 'rgba(255, 214, 0, 1)';
      } else {
        return 'rgba(0, 182, 122, 1)';
      }
    },
    activeBarStep() {
      return this.progressbarSteps[this.activeStep];
    },
  },

  mounted() {
    const interval = 100;
    this.timer = setInterval(() => {
      this.activeBarStep.progress += 100 * interval / (this.countDown * 1000);
      if (this.activeBarStep.progress > 100) {
        this.activeBarStep.progress = 100;
        this.activeStep++;
      }
    }, interval);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  watch: {
    activeStep(val) {
      if (val >= this.progressbarSteps.length) {
        clearInterval(this.timer);
        setTimeout(() => this.$emit("loaded"), 300);
      }
    },
  },

  methods: {

  },
}
</script>

<style lang="sass" scoped>
.loading-bar
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: relative
  width: 100%
  max-width: 343px

  h2
    color: rgba(32, 40, 56, 1)
    font-size: 24px
    line-height: 30px
    font-weight: 600
    text-align: center
    margin-bottom: 22px

  .loading__steps
    display: flex
    flex-direction: column
    gap: 8px
    width: 100%

  .step
    display: flex
    flex-direction: column
    padding: 13px 15px
    background: rgba(240, 240, 240, 1)
    border-radius: 10px

    .progress
      position: relative
      background: rgba(255, 255, 255, 1)
      height: 5px
      width: 100%
      border-radius: 40px

      .current-progress
        background: rgba(85, 181, 166, 1)
        transition: .3s ease
        height: 100%
        border-radius: 40px

    .step__header
      display: flex
      align-items: center
      justify-content: space-between
      gap: 12px
      margin-bottom: 12px

    p, .percentage
      color: rgba(32, 40, 56, 1)
      font-size: 14px
      line-height: 17px
      font-weight: 600
      text-align: left

    .percentage
      text-align: right
      color: rgba(105, 109, 116, 1)
</style>
